import * as React from 'react';

import { api } from '../../environment';
import Table from '../../components/table/Table';
import CheckBox from '../../components/formElements/CheckBox';
import { RemoveRedEye } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import {utils, write}from 'xlsx';
import { saveAs } from 'file-saver';
import { FormDataBuilder, makeFormControls } from '../../components/formElements/util';
import Form from '../../components/formElements/Form';

export default function AbstractsView(){
    const [dataRows, setDataRows] = React.useState([]);
    

    const orderData = (data)=>{
        console.log("ORDER", data)
        return data.map((row, index) =>{
            row['order'] = index+1;
            return  row;
        })
    }

    const defineActions = (data)=>{
        return data.map((row, index)=>{
             row['action'] = <Link to={"/crs/pregled-sazetaka/"+row['id']}><RemoveRedEye/></Link>
             return row;
        })
    };


    const getData = (body) => {
        let call = fetch(api+"/get_abstracts",{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
              },
              
              body:JSON.stringify({token:localStorage.getItem('site'), criteria:filter, ...body})
            })
            try{
        return call.then(response=>response.json())
            } catch (err){
                console.log(err)
                return [];
            }
    }

    const header = [{name:"order", label:"#", width:"5%"},{name:"activity_title", label:"Naslov", width:"25%", overflowX:'scroll'}, {name:"type", label:"Oblik sudjelovanja", width:"25%"}, {name:'theme', label:'Tematsko područje', width:"20%", overflowX:"scroll"}, {name:"status", label:"Status prijave", width:"20%"}, {name:"action", label:"akcija", width:"5%"}, ]

    const valueMapper = (name, value) => {
        let mapping = {
            "type" : {
                1: "Usmeno izlaganje",
                2: "Poster izlaganje",
                3: "Simpozij",
                4: "Okrugli stol",
                5: "Radionica",
                6: "Stručni domjenak",
                7: "Sastanak",
                8: "Predstavljanje",
                9: "Izvan okvira",
                10: "Kreativci",
                11: "Ostalo"
            },
            "theme":{
                "1": "Mentalno zdravlja djece i mladih u doba globalnih kriza",
                "2": "Emocionalna otpornost u kriznim situacijama: strategije za pojedince i obitelji",
                "3": "Roditeljstvo u kriznim vremenima – izazovi, prilagodbe i uloga psihološke podrške",
                "4": "Uloga digitalnih tehnologija i mentalno zdravlje",
                "5": "Uloga zajednice u prevenciji ovisnosti",
                "6": "Profesionalno umrežavanje kao odgovor na krizne situacije",
                "7": "Organizacijska psihologija u vrijeme digitalne transformacije društva",
                "8": "Mentalno zdravlje i otpornost sportaša",
                "9": "Krizna razdoblja adolescencije i mlađe odrasle dobi: veza slike tijela i poremećaja hranjenja",
                "10": "Mentalno zdravlje zaposlenika u digitalnom dobu: prilagodba, inovacije i otpornost",
                "11": "Otpornost i dobrobit starijih osoba u izazovnim situacijama",
                "12": "Seksualnost, seksualne orijentacije i rodni identitet kroz životni vijek",
                "13": "Psihologija i ljudska prava",
                "14": "Mentalno zdravlje i otpornost pojedinaca i grupa u kontekstu ratnih zbivanja",
                "15": "Učenje budućnosti: izazovi umjetne inteligencije",
                "16": "Izvrsnost i odličan uspjeh tijekom školovanja – garancija znanja ili ne?",
                "17": "Mediji i mentalno zdravlje mladih",
                "18": "Otpornost učenika u uvjetima obrazovnih promjena: Uloga školskog psihologa u prevenciji i intervenciji",
                "19": "Suradnja psihologa s roditeljima u dječjem vrtiću: izazovi i mogućnosti",
                "20":  "Uloga psihologa u prepoznavanju i podršci djece s različitim putevima razvoja"
            },
            "status":{
                0: "Čeka pregled",
                1: "Poslano na recenziju",
                2: "Prihvaćeno",
                3: "Prihvaćeno uz izmjene",
                4: "Odbijeno"
            },
            "independent":{
                0:"Samostalna aktivnost",
                1:"Aktivnost u okviru simpozija"
            }

        }
        if(mapping[name]==undefined) return value;
        console.log("VALUE",mapping[name][value])
        return mapping[name][value]
    }

    const mapValues = (data) =>{
        return data.map((row, index)=>{
            for(let name in row){
                row[name] = valueMapper(name,row[name])
            }
            return row
        })
    }

    // const mapValues = (data) =>{
    //     for(let row of data){
    //         row['type'] = mapType(row['type']);
    //         row['theme'] = mapTheme(row['theme']);
    //         row['status'] = mapStatus(row['status']);
    //     }
    //     return data
    // }

    const filterFormData = (new FormDataBuilder())
    .addTextField('activity_title', 'Pretraži naslove', false, false, [], {flex:"1 1 20%"}, null, 'input-field-no-border input-bottom-border')
    .addSelectField('type', 'Tip izlaganja', false, [
        {value:"0", text:'Sve'},
        {value:"1", text:"Usmeno izlaganje"},
    {value:"2", text:"Poster izlaganje"},
    {value:"3", text:"Simpozij"},
    {value:"4", text:"Okrugli stol"},
    {value:"5", text:"Radionica"},
    {value:"6", text:"Stručni domjenak"},
    {value:"7", text:"Sastanak stručne sekcije/radne skupine"},
    {value:"8", text:"Predstavljanje knjiga, psihologijskih mjernih instrumenata te drugih publikacija i uradaka"},
    {value:"9", text:'„Izvan okvira"'},
    {value:"10", text:"Psiholozi kao kreativci"},
    {value:"11", text:"Ostale aktivnosti"}
        
    ], false,[], {flex:'1 1 20%'}, null, 'input-field-no-border input-bottom-border')
    .addSelectField('theme', 'Tematsko područje', false, [
        {value:"1", text:"Mentalno zdravlja djece i mladih u doba globalnih kriza"},
        {value:"2", text:"Emocionalna otpornost u kriznim situacijama: strategije za pojedince i obitelji"},
        {value:"3", text:"Roditeljstvo u kriznim vremenima – izazovi, prilagodbe i uloga psihološke podrške"},
        {value:"4", text:"Uloga digitalnih tehnologija i mentalno zdravlje"},
{value:"5", text:"Uloga zajednice u prevenciji ovisnosti"},
{value:"6", text:"Profesionalno umrežavanje kao odgovor na krizne situacije"},
{value:"7", text:"Organizacijska psihologija u vrijeme digitalne transformacije društva"},
{value:"8", text:"Mentalno zdravlje i otpornost sportaša"},
 {value:"9", text:"Krizna razdoblja adolescencije i mlađe odrasle dobi: veza slike tijela i poremećaja hranjenja"},
{value:"10", text:"Mentalno zdravlje zaposlenika u digitalnom dobu: prilagodba, inovacije i otpornost"},
{value:"11", text:"Otpornost i dobrobit starijih osoba u izazovnim situacijama"},
{value:"12", text:"Seksualnost, seksualne orijentacije i rodni identitet kroz životni vijek"},
{value:"13", text:"Psihologija i ljudska prava"},
{value:"14", text:"Mentalno zdravlje i otpornost pojedinaca i grupa u kontekstu ratnih zbivanja"},
{value:"15", text:"Učenje budućnosti: izazovi umjetne inteligencije"},
{value:"16", text:"Izvrsnost i odličan uspjeh tijekom školovanja – garancija znanja ili ne?"},
{value:"17", text:"Mediji i mentalno zdravlje mladih"},
{value:"18", text:"Otpornost učenika u uvjetima obrazovnih promjena: Uloga školskog psihologa u prevenciji i intervenciji"},
{value:"19", text:"Suradnja psihologa s roditeljima u dječjem vrtiću: izazovi i mogućnosti"},
{value:"20", text:"Uloga psihologa u prepoznavanju i podršci djece s različitim putevima razvoja"}
    ], false,[], {flex:'1 1 20%'}, null, 'input-field-no-border input-bottom-border')
    .addSelectField('status', 'Status', false, [
        {value:"-1", text:'Sve'},
        {value:'0', text:'Čeka pregled'},
        {value:'1', text:'Na recenziji'},
        {value:'2', text:'Prihvaćena'},
        {value:'3', text:'Prihvaćena uz izmjene'},
        {value:'4', text:'Odbijena'}
    ], false,[], {flex:'1 1 20%'}, null, 'input-field-no-border input-bottom-border').get();
    
    const [filter, setFilter] = React.useState(makeFormControls(filterFormData));

    React.useEffect(()=>{
        getData().then(
            data=>setDataRows(defineActions(orderData(mapValues(data))))
        )
    }, [filter])

    

    const exportToExcel = (data, fileName) => {
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
        saveAs(blob, `${fileName}.xlsx`);
      };

      const mutateDataForExport = (data) =>{
        const mapping = {

        }

        

        return data.map((row, index)=>{
            let mapping = {
                "type": "Vrsta izlaganja",
                "activity_title": "Naslov",
                "independent":"U okviru simpozija",
                "parent_activity_title": "Simpozij",
                "presenter": "Voditelj izlaganja",
                "presenter_email": "E-Mail adresa voditelja izlaganja",
                "contact": "Osoba za kontakt",
                "contact_email": "E-Mail adresa osobe za kontakt",
                "active_participant_string": "Autori",
                "theme": "Tematsko područje",
                "note": "Napomena",
                "status":"Status prijave"
            }
            let mutatedRow = {}
            for(let name in mapping){
                mutatedRow[mapping[name]] = row[name]
            }
        mutatedRow["Status prijave"] = row["status"]
            console.log(row);
            return mutatedRow
        })


    }


    return (
        <>
        <h1 style={{marginBottom:"2rem"}}>Pregled prijava sažetaka</h1>
        <div className="input-field" style={{marginTop:"0.5rem"}}>
            <div className="flex-row" style={{gap:"1%"}}>
        <Form formData={filterFormData} formControls={filter} setFormControls={setFilter}/>
        </div>
        <Table header={header} dataSource={dataRows!=undefined?dataRows:[]} layout="fixed"/>
        <button className="modal-button" style={{margin:"1rem"}}  onClick={()=>{exportToExcel(mutateDataForExport(dataRows), 'aktivnosti')}}>Izvoz u Excel</button>
        </div>
        </>
    )
}